/**
 * StatusMessage.jsx
 *
 * Idle, loading ve error durumlarını kullanıcıya gösterir.
 * SOLID - Single Responsibility: Sadece durum mesajlamasından sorumludur.
 */

import React from "react";

function StatusMessage({ status, errorText }) {
  if (status === "idle") {
    return (
      <div className="status-message status-message--idle" role="status">
        <div className="status-message__icon" aria-hidden="true">🔍</div>
        <p className="status-message__text">
          Türkçe bir soru yazın. Semantic Router otomatik olarak en uygun
          motoru (FAISS veya pgvector) seçecek.
        </p>
      </div>
    );
  }

  if (status === "loading") {
    return (
      <div className="status-message status-message--loading" role="status" aria-live="polite">
        <span className="spinner spinner--large" aria-hidden="true" />
        <p className="status-message__text">Vektör araması yapılıyor...</p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="status-message status-message--error" role="alert" aria-live="assertive">
        <div className="status-message__icon" aria-hidden="true">⚠️</div>
        <p className="status-message__text">{errorText || "Bir hata oluştu."}</p>
      </div>
    );
  }

  return null;
}

export default StatusMessage;
